import type { JobAd } from '../../types';
import { formatRelativeDate } from '../lib/formatDate';

export function getDateLocation(
    ad: JobAd,
    {
        currentTime,
        isDeadLineToday = false,
    }: { currentTime?: number; isDeadLineToday?: boolean } = {},
) {
    if (isDeadLineToday) {
        return ad.location ?? '';
    }

    const publishedDate = formatRelativeDate(ad.timestamp, {
        currentTime,
        newTodayText: true,
    });

    if (ad.location) {
        return publishedDate + ' ∙ ' + ad.location;
    }

    return publishedDate;
}
